__turbopack_context__.v({
  "container": "uid-module-scss-module__2bix6a__container",
});
